export var ILogoutMessageType;
(function (ILogoutMessageType) {
    ILogoutMessageType["LOGOUT"] = "logout";
    ILogoutMessageType["SWITCH"] = "switch";
    ILogoutMessageType["LOGIN"] = "login";
})(ILogoutMessageType || (ILogoutMessageType = {}));
